import React from 'react'

const getIllinoisPricingText = (illinois, price) => {
  const priceText = `$${price.toFixed(2)}`
  let text = `Chicago Residents ${priceText}`
  if (illinois) {
    text =
      price > 0
        ? `Illinois Residents ${priceText}`
        : 'Illinois Residents Free Today'
  }
  return text
}

const renderIllinois = (chicago, illinois) => {
  if (illinois || chicago) {
    const defaultPrice = illinois ? illinois : chicago
    const price = defaultPrice.price
    const text = getIllinoisPricingText(illinois, price)
    return <React.Fragment>({text})</React.Fragment>
  }
}

const renderDynamicIllinois = (chicago, illinois) => {
  if (illinois || chicago) {
    const defaultPrice = illinois ? illinois : chicago
    const price = defaultPrice.price
    let text = `$${price.toFixed(2)}`
    if (illinois) {
      text = price > 0 ? `$${price.toFixed(2)}` : 'Free Today'
    }
    return <React.Fragment>{text}</React.Fragment>
  }
}

const formattedPrice = (defaultPrice, addon) => {
  if (defaultPrice == null && !addon) {
    return
  } else {
    return defaultPrice === 0 ? 'Free' : `$${defaultPrice.toFixed(2)}`
  }
}

const getDefaultPrice = (employee, addon) => {
  let defaultPrice = null
  if (employee) {
    defaultPrice = employee.price
  }
  if (!defaultPrice && addon) {
    defaultPrice = addon.price
  }
  return defaultPrice
}

function Price({ price, member, isDynamicPricing }) {
  let {
    types: { default: defaultPrice, chicago, illinois, addon, employee },
    label
  } = price

  const dynamicAgeGroups = [
    'adult',
    'adult2',
    'youth',
    'youth2',
    'child',
    'child2'
  ]

  const mainPrice = defaultPrice
    ? defaultPrice.price
    : getDefaultPrice(employee, addon)
  if (
    isDynamicPricing &&
    !member &&
    dynamicAgeGroups.includes(price.ageGroup)
  ) {
    if (chicago || illinois) {
      return (
        <li className="my-8">
          <span className="font-bold mr-4">
            {chicago
              ? `Chicago Resident ${label}:`
              : `Illinois Resident ${label}:`}
          </span>
          {renderDynamicIllinois(chicago, illinois)}
        </li>
      )
    } else return null
  } else {
    return (
      <li className="my-8">
        <span className="font-bold mr-4">
          {member ? `Member ${label}` : label}:
        </span>
        {formattedPrice(mainPrice, addon)} {renderIllinois(chicago, illinois)}
      </li>
    )
  }
}

export default Price
